(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;
		//this.throttledScrollHandler = throttle(this.onScrollHandler, 300);

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
		this.header.style.transform = 'translateY(-100%)';
	};

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
		this.header.classList.remove('color-background-2');
		this.header.style.transition = 'background var(--duration-short)';
		this.header.style.transform = 'translateY(0)';
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
		this.header.style.transform = 'translateY(0)';
		this.header.style.transition = 'background var(--duration-short)';
		if (this.header.classList.contains('color-background-1')) {
		this.header.classList.add('color-background-2');
		};
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		if (document.querySelector(".overflow-hidden-tablet")) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		if (document.querySelector('.entering-section')) {
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
		}
		else{
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden','color-background-2');
		}
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		if (this.header.classList.contains('color-background-1')) {
			this.header.classList.add('color-background-2');
		};
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close();
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true);
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  //class CartNote extends HTMLElement {
  //  constructor() {
  //    super();

  //    this.addEventListener(
  //      'change',
  //      debounce((event) => {
  //        const body = JSON.stringify({ note: event.target.value });
  //        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
  //      }, 300)
  //    );
  //  }
  //}

  //customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
	constructor() {
		super();

		this.isProductPage = true
	}

	hide() {
		super.hide(this.isProductPage);
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();		
	}

	showActiveMedia() {
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		if (activeMedia) {
				activeMedia.classList.add('active');
				activeMedia.scrollIntoView();
		}
		if (activeMedia?.nodeName == 'DEFERRED-MEDIA' && activeMedia?.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

customElements.define('product-modal', ProductModal);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portfolio-lightbox"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__pfInit) return;
  window.__pfInit = true;

  var ALL = '__all__';

  function galleries() {
    return Array.prototype.slice.call(document.querySelectorAll('.pf-gallery'));
  }

  /* ---------- Filter bar ---------- */
  function buildFilter() {
    var bar = document.querySelector('.pf-filter');
    if (!bar) return;
    var gals = galleries();
    if (!gals.length) return;

    var allLabel = bar.getAttribute('data-all-label') || 'All';
    var cats = [];
    var seen = {};
    gals.forEach(function (g) {
      var c = g.getAttribute('data-pf-category') || 'all';
      var l = g.getAttribute('data-pf-label') || c;
      if (!seen[c]) { seen[c] = true; cats.push({ cat: c, label: l }); }
    });
    if (cats.length < 2) return; /* nothing to filter */

    var defs = [{ cat: ALL, label: allLabel }].concat(cats);
    defs.forEach(function (d, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pf-filter__btn';
      b.textContent = d.label;
      b.setAttribute('data-cat', d.cat);
      b.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
      b.addEventListener('click', function () { applyFilter(d.cat); });
      bar.appendChild(b);
    });
    bar.removeAttribute('hidden');
  }

  function applyFilter(cat) {
    galleries().forEach(function (g) {
      var c = g.getAttribute('data-pf-category') || 'all';
      if (cat === ALL || c === cat) g.removeAttribute('hidden');
      else g.setAttribute('hidden', '');
    });
    var bar = document.querySelector('.pf-filter');
    if (bar) {
      Array.prototype.forEach.call(bar.querySelectorAll('.pf-filter__btn'), function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-cat') === cat ? 'true' : 'false');
      });
    }
  }

  /* ---------- Lightbox ---------- */
  var overlay, imgEl, list = [], idx = 0;

  function visibleItems() {
    return Array.prototype.slice.call(document.querySelectorAll('.pf-item')).filter(function (a) {
      var g = a.closest('.pf-gallery');
      return !g || !g.hasAttribute('hidden');
    });
  }

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'pf-lb';
    overlay.setAttribute('hidden', '');
    overlay.innerHTML =
      '<button class="pf-lb__close" type="button" aria-label="Close">×</button>' +
      '<button class="pf-lb__nav pf-lb__prev" type="button" aria-label="Previous">‹</button>' +
      '<img class="pf-lb__img" alt="">' +
      '<button class="pf-lb__nav pf-lb__next" type="button" aria-label="Next">›</button>';
    document.body.appendChild(overlay);
    imgEl = overlay.querySelector('.pf-lb__img');
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    overlay.querySelector('.pf-lb__close').addEventListener('click', close);
    overlay.querySelector('.pf-lb__prev').addEventListener('click', function (e) { e.stopPropagation(); show(idx - 1); });
    overlay.querySelector('.pf-lb__next').addEventListener('click', function (e) { e.stopPropagation(); show(idx + 1); });
    document.addEventListener('keydown', function (e) {
      if (!overlay || overlay.hasAttribute('hidden')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(idx - 1);
      else if (e.key === 'ArrowRight') show(idx + 1);
    });
  }

  function show(i) {
    if (!list.length) return;
    idx = (i + list.length) % list.length;
    imgEl.src = list[idx].getAttribute('data-full') || list[idx].href;
    imgEl.alt = (list[idx].querySelector('img') || {}).alt || '';
  }

  function open(item) {
    list = visibleItems();
    var i = list.indexOf(item);
    if (i < 0) { list = [item]; i = 0; }
    if (!overlay) build();
    show(i);
    overlay.removeAttribute('hidden');
    document.documentElement.classList.add('pf-lb-open');
  }

  function close() {
    if (!overlay) return;
    overlay.setAttribute('hidden', '');
    document.documentElement.classList.remove('pf-lb-open');
    imgEl.src = '';
  }

  document.addEventListener('click', function (e) {
    var item = e.target.closest('.pf-item');
    if (!item) return;
    e.preventDefault();
    open(item);
  });

  function init() { buildFilter(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

  } catch(e) { console.error(e); }
})();
})();
